import { InjectionToken, Signal } from '@angular/core';
import {
  FeedbackClientContext,
  FeedbackSubmitRequest,
  FeedbackSubmitResponse,
  FeedbackUserTypeEnum,
} from '@jfw/types';
import { Observable } from 'rxjs';

/**
 * EXT-6239: what a portal supplies so the shared feedback dialog can run in
 * it. Each portal provides one under FEEDBACK_DIALOG_HOST.
 */
export interface FeedbackDialogHost {
  /** Shown as the user-type tag. The API stamps the real one server-side. */
  readonly userType: FeedbackUserTypeEnum;
  /** Who the "sent" message says received it, e.g. "Platform Portal team". */
  readonly teamName: string;
  /** The signed-in user, for the "Included automatically" box. */
  readonly user: Signal<{ name: string; email: string } | null>;
  snapshot(): FeedbackClientContext;
  submit(request: FeedbackSubmitRequest): Observable<FeedbackSubmitResponse>;
  /** Opens the submitter's "My feedback" page. The dialog hides its links to
   * it when the portal has no such page. */
  openMyFeedback?(): void;
}

export const FEEDBACK_DIALOG_HOST = new InjectionToken<FeedbackDialogHost>(
  'FEEDBACK_DIALOG_HOST',
);
